"use strict";

const state = {
  activateRefresh: {
    refreshed: false
  },
};

const mutations = {
  SOCKET_REFRESH_VISITS(state) {
    state.activateRefresh.refreshed = true;
  },
  SOCKET_REFRESH_SECURITY_VISITS(state) {
    state.activateRefresh.refreshed = true;
  },
};

const actions = {};

export default {
  state,
  mutations,
  actions
};
